// components/TripCard.jsx
import React from 'react';
import { Plane, Bus, Calendar } from 'lucide-react';

const TripCard = ({ trip }) => (
    <div className="flex flex-col sm:flex-row items-start sm:items-center p-4 bg-[#F4F8E9] rounded-lg hover:bg-[#E8F0D9] transition-colors cursor-pointer space-y-3 sm:space-y-0">
        <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-[#96B734] bg-opacity-20 rounded-lg flex items-center justify-center">
                {trip.type === 'avion' ? (
                    <Plane className="w-6 h-6 text-[#437011]" />
                ) : (
                    <Bus className="w-6 h-6 text-[#437011]" />
                )}
            </div>
        </div>
        <div className="ml-4 flex-1">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h3 className="text-sm font-medium text-[#437011]">{trip.from} → {trip.to}</h3>
                    <p className="text-sm text-gray-600">{trip.compagnie} - {trip.type === 'avion' ? trip.flightNo : trip.busNo}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium mt-2 sm:mt-0 ${
                    trip.status === 'confirmé'
                        ? 'bg-[#96B734] text-white'
                        : 'bg-[#FF8A3D] text-white'
                }`}>
                    {trip.status}
                </span>
            </div>
            <div className="mt-2 flex items-center text-sm text-gray-500">
                <Calendar className="w-4 h-4 mr-2" />
                {new Date(trip.date).toLocaleDateString()}
            </div>
        </div>
    </div>
);

export default TripCard;